export default __webpack_public_path__ + "static/media/adrenalgland.90a4cd70.PNG";